import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Flex, Typography } from 'front-commons/ds';
import { useState } from 'react';
import { OrderSummaryProps } from './interfaces';
import { ResumeTrigger } from './components/ResumeButton';
import { PriceSection, Content, Portal, WrapperPrice } from './styles';

export function OrderSummary({ price, discount, taxSubstitution, finalPrice }: OrderSummaryProps) {
	const [expanded, setExpanded] = useState(false);

	return (
		<Flex direction="column" gap="0" width="100%">
			<DropdownMenu.Root
				open={expanded}
				data-testid="promotion-details-order-summary"
				onOpenChange={() => setExpanded((prevState) => !prevState)}
			>
				<Flex as={DropdownMenu.Trigger} cursor="pointer" padding="0" height="20px" margin="0 0 8px">
					<ResumeTrigger
						expanded={true}
						opacity={expanded ? '0' : '1'}
						data-testid="order-summary-final-price-trigger"
					/>
				</Flex>

				<PriceSection alignItems="center" justifyContent="space-between">
					<Flex alignItems="center" gap="8px">
						<Typography>Total</Typography>
					</Flex>

					<Typography variant="Label/Large">{Number(finalPrice).toCurrency()}</Typography>
				</PriceSection>

				<Portal>
					<Content side="top" align="center" sideOffset={0}>
						<Flex
							as="button"
							cursor="pointer"
							padding="0"
							height="20px"
							margin="0 0 16px"
							onClick={() => setExpanded(false)}
						>
							<ResumeTrigger expanded={false} data-testid="order-summary-portal-trigger" />
						</Flex>

						<WrapperPrice direction="column" gap="8px">
							<Flex justifyContent="space-between">
								<Typography variant="ParagraphSmall/Regular">
									Subtotal <Typography variant="Paragraph/Semibold">(Preço De)</Typography>
								</Typography>
								<Typography variant="ParagraphSmall/Regular" as="span">
									{Number(price).toCurrency()}
								</Typography>
							</Flex>
							<Flex justifyContent="space-between">
								<Typography variant="ParagraphSmall/Regular">Desconto</Typography>
								<Typography variant="ParagraphSmall/Regular" as="span">
									{Number(discount).toCurrency({ operator: '-' })}
								</Typography>
							</Flex>
							<Flex justifyContent="space-between">
								<Typography variant="ParagraphSmall/Regular">Impostos</Typography>
								<Typography variant="ParagraphSmall/Regular" as="span">
									{Number(taxSubstitution).toCurrency()}
								</Typography>
							</Flex>
						</WrapperPrice>
					</Content>
				</Portal>
			</DropdownMenu.Root>
		</Flex>
	);
}
